module.exports = __webpack_public_path__ + "static/img/sftp1.2a0472d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/joinus/sftp1.png
// module id = saCs
// module chunks = 1